module.exports = __webpack_public_path__ + "static/86-1-ed40cae6ad06c4c062c8667f6b454d16.jpg";